import GetChannelFiltersRequest from "./GetChannelFiltersRequest"

class GetNoticeFiltersRequest extends GetChannelFiltersRequest {
    constructor({communityId}) {
        super({communityId})
    }
}

export default GetNoticeFiltersRequest